const slideUp = (el, duration = 300) => {
	el.style.height = el.offsetHeight + "px";
	el.offsetHeight;
	el.style.transitionProperty = "height, margin, padding";
	el.style.transitionDuration = duration + "ms";
	el.style.transitionTimingFunction = "ease";
	el.style.overflow = "hidden";
	el.style.height = 0;
	el.style.paddingTop = 0;
	el.style.paddingBottom = 0;
	el.style.marginTop = 0;
	el.style.marginBottom = 0;
	setTimeout(() => {
		el.style.display = "none";
		el.style.removeProperty("height");
		el.style.removeProperty("padding-top");
		el.style.removeProperty("padding-bottom");
		el.style.removeProperty("margin-top");
		el.style.removeProperty("margin-bottom");
		el.style.removeProperty("overflow");
		el.style.removeProperty("transition-duration");
		el.style.removeProperty("transition-property");
		el.style.removeProperty("transition-timing-function");
	}, duration);
};

// slideDown
const slideDown = (el, duration = 300) => {
	el.style.removeProperty("display");
	let display = window.getComputedStyle(el).display;
	if (display === "none") {
		display = "block";
	}
	el.style.display = display;
	let height = el.offsetHeight;
	el.style.overflow = "hidden";
	el.style.height = 0;
	el.style.paddingTop = 0;
	el.style.paddingBottom = 0;
	el.style.marginTop = 0;
	el.style.marginBottom = 0;
	el.offsetHeight;
	el.style.transitionProperty = "height, margin, padding";
	el.style.transitionDuration = duration + "ms";
	el.style.transitionTimingFunction = "ease";
	el.style.height = height + "px";
	el.style.removeProperty("padding-top");
	el.style.removeProperty("padding-bottom");
	el.style.removeProperty("margin-top");
	el.style.removeProperty("margin-bottom");
	setTimeout(() => {
		el.style.removeProperty("height");
		el.style.removeProperty("overflow");
		el.style.removeProperty("transition-duration");
		el.style.removeProperty("transition-property");
		el.style.removeProperty("transition-timing-function");
	}, duration);
};

// slideToggle関数（既存）
const slideToggle = (el, duration = 300) => {
	if (window.getComputedStyle(el).display === "none") {
		return slideDown(el, duration);
	} else {
		return slideUp(el, duration);
	}
};

// PRODUCT SERIES用
const productEl = document.querySelector(".collection-list");
const productBtn = document.querySelector(".collection-nav-item");

if (productBtn && productEl) {
	productBtn.addEventListener("click", () => {
		slideToggle(productEl, 600);
		productBtn.classList.toggle("active");
	});
}

// SELECT BY TYPE (lifestyle) 用
const lifestyleEl = document.querySelector(".lifestyle-list-wrapper");
const lifestyleBtn = document.querySelector(".lifestyle-nav-item");

if (lifestyleBtn && lifestyleEl) {
	lifestyleBtn.addEventListener("click", () => {
		slideToggle(lifestyleEl, 600);
		lifestyleBtn.classList.toggle("active");
		lifestyleEl.classList.toggle("active");
	});
}

// currentクラス追加
$(function () {
	// PRODUCT SERIES
	var productValue = $(".collection-list").attr("data-collection");
	$(".collection-list [data-collection=" + productValue + "]").addClass("current");
});

$(function () {
	// TAG NAV
	var currentPath = window.location.pathname;
	var pathSegments = currentPath.split("/").filter(Boolean);
	var currentTag = pathSegments[pathSegments.length - 1];

	// コレクションページのベースURLの場合は "all"
	if (pathSegments.length === 2 || currentPath.endsWith("/")) {
		currentTag = "all";
	}

	$('.lifestyle-item[data-tag="' + currentTag + '"]').addClass("current");
});
